module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f803a18aad32338b02b679c8de283825.gif";